import { GetApiData } from './fetchConfig';

export const useExistingOwnersForObjects = (fleetId) => {
  return GetApiData(`organizationroles/fleets/${fleetId}/owners`);
};
export const useOwnersFromLLIforObjects = (fleetId) => {
  return GetApiData(`fleets/${fleetId}/insured-objects/lli-ownerships`);
};
